// extracted by mini-css-extract-plugin
export default {"sub-text":"PercentageVATCalculator_sub-text__iWAEQ","edit-button":"PercentageVATCalculator_edit-button__PQVf+","inline-input":"PercentageVATCalculator_inline-input__Ior2f"};